import Searchbar from "../components/Searchbar";
import { useContext, useState } from "react";
import { HarvestContext } from "../store/HarvestContext";
import { ModalContext } from "../store/ModalContext";
import type { HarvestProduct } from "../utils/types";
import HarvestInventoryBusiness from "../components/HarvestInventoryBusiness";
import { AddProductModalBody } from "../modals/AddProductModalBody";

const HarvestManagerBusinessPage = () => {
  const [searchProductList, setSearchProductList] = useState<
    HarvestProduct[]
  >([]);
  const [currentTypedSearch, setCurrentTypedSearch] = useState("");
  const { harvestProducts } = useContext(HarvestContext);
  const { openModal, closeModal } = useContext(ModalContext);

  function filterProducts(value: string) {
    const filteredProducts = harvestProducts.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase()),
    );
    setSearchProductList(filteredProducts);
    setCurrentTypedSearch(value);
  }

  return (
    <div className="page-container harvest-manager">
      <h1>Business Inventory</h1>
      <div className="page-content">
        <div className="business-inventory-search-n-add">
          <Searchbar
            action={filterProducts}
            placeholder={"Search for product..."}
          />
          <button
            className="btn"
            onClick={() =>
              openModal({
                title: "New Product",
                showCloseButton: true,
                body: <AddProductModalBody onClose={closeModal} />,
              })
            }
          >
            Add New Product
          </button>
        </div>
        <HarvestInventoryBusiness
          searchProductList={searchProductList}
          currentTypedSearch={currentTypedSearch}
        />
      </div>
    </div>
  );
};

export default HarvestManagerBusinessPage;
